import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import ResultsImports from './ImportResults';
import agm from '../../services/agm';
import Alerts from '../../utils/alerts';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    Button,
    Card,
    CardContent
} from '@material-ui/core';

import { RiAlarmWarningFill } from "react-icons/ri";

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200],
        color: colors.cyan[400]
    },
    container: {
        maxHeight: 495,
    }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const importsResultColumns = [
    { name: 'OT', field: 'item.numero', size: 30, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'SA', field: 'item.numerosa', size: 30, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Data de criação', field: 'item.abertura', size: 90, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Agência', field: 'item.Conta + " - " + item.Agencia', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Categoria', field: 'item.Categoria', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Descrição', field: 'item.descricao', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Sintoma', field: 'item.Sintoma', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Local do Sintoma', field: 'item.Local', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Data limite 1º atendimento', field: 'item.dataLimitePrimeiroAtendimento', size: 90, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Data limite conclusão', field: 'item.dataLimiteConclusaoSla', size: 90, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Tipo Ocorr.', field: '(item.tipoOcorrencia == 1 ? "Corretiva" : "Preventiva")', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Tipo Atend.', field: '(item.tipoAtendimento == 3 ? "Normal" : "Preventiva")', size: -1, sortable: 0, exportable: 0, wrap: 0 }
];

const importEmptyMessage = 'Todas as ocorrências já foram criadas ou não foram encontradas nos arquivos.';

const importFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: importEmptyMessage,
    columns: importsResultColumns
};

const importCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: importEmptyMessage,
    columns: importsResultColumns
};

const importResultModes = [importFullMode, importCompactMode];

const Treatment = ({ item, open, closeTreatment, updateTreatmentValues, dependencies, selectedMode }) => {

    const classes = useStyles();

    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };


    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Importação de Ocorrências
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({

                            })
                        }
                        onSubmit={(values, formik) => {
                            updateTreatmentValues(values);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid
                                    container
                                    spacing={2}
                                    xs="auto">

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>

                                        <Card>
                                            <CardContent>

                                                <Grid container
                                                    direction="row"
                                                    justifyContent="flex-start"
                                                    alignItems="center"
                                                    spacing={1}  >

                                                    <Grid item
                                                        md={12}
                                                        xs={12}>

                                                        <ResultsImports
                                                            resultSet={{
                                                                loaded: true,
                                                                records: item.report.length,
                                                                pages: 1,
                                                                page: 1,
                                                                count: item.report.length,
                                                                rows: item.report
                                                            }}
                                                            procerrors={item.errors}
                                                            resultModes={importResultModes}
                                                            icon={RiAlarmWarningFill}
                                                            selectedMode={selectedMode}
                                                            openTreatment={() => { }}
                                                            values={values}
                                                        />

                                                    </Grid>

                                                </Grid>

                                            </CardContent>
                                        </Card>
                                    </Grid>

                                </Grid>

                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Executar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeTreatment() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Treatment;
